/** Site-wide branding, location, and canonical URLs */
export const SITE = {
  name: 'CEE',
  fullName: 'Core Elite Experts',
  legalName: 'Core Elite Experts (Private) Limited',
  title: 'Core Elite Experts | Freelancing Services in Gilgit, Pakistan',
  description:
    'Core Elite Experts is a Gilgit, Pakistan-based freelancing company offering DevOps, cloud engineering, software development, bookkeeping, digital marketing, UI/UX design, and business support for startups and SMEs worldwide.',
  tagline: 'Freelancing & digital solutions from Gilgit, Pakistan',
  url: 'https://coreeliteexperts.com',
  logo: '/logo-cee.png',
  ogImage: '/logo-cee.png',
  favicon: '/favicon.svg',
  faviconPng: '/favicon.png',
  twitterHandle: '@coreeliteexperts',
  locale: 'en_PK',
  language: 'English',
  founded: '2024',
  keywords: [
    'freelancing services Pakistan',
    'freelancing company Gilgit',
    'DevOps freelancer Pakistan',
    'cloud engineering services',
    'software development Gilgit',
    'bookkeeping services Pakistan',
    'digital marketing freelancer',
    'UI UX design services',
    'remote freelancing team',
    'Core Elite Experts',
    'Gilgit Baltistan IT services',
    'Upwork agency Pakistan',
    'business support outsourcing',
  ],
  location: {
    streetAddress: 'Danyore',
    city: 'Gilgit',
    region: 'Gilgit-Baltistan',
    country: 'Pakistan',
    countryCode: 'PK',
    postalCode: '15100',
    latitude: 35.918,
    longitude: 74.308,
    formatted: 'Danyore, Gilgit-Baltistan, Pakistan',
  },
  contact: {
    email: 'info@coreeliteexperts.com',
    phone: '+92-355-4475474',
  },
  services: [
    'DevOps & Cloud Engineering',
    'Software Development',
    'Bookkeeping & Finance',
    'Digital Marketing & SEO',
    'UI/UX Design',
    'Video Editing',
    'Business Support',
  ],
  social: {
    twitter: 'https://twitter.com/coreeliteexperts',
    linkedin: 'https://www.linkedin.com/company/coreeliteexperts',
  },
} as const;
